import '../common.entrance';
import Vue from 'vue';
import ForgotPasswordSuccessModal from '../components/modals/ForgotPasswordSuccessModal.vue';

document.addEventListener('DOMContentLoaded', () => {
  const mountElement = document.getElementById('forgot-password-success-modal');
  if (!mountElement) {
    return;
  }

  new Vue({
    el: mountElement,
    components: {
      ForgotPasswordSuccessModal,
    },
    render(createElement) {
      return createElement('forgot-password-success-modal', {
        props: {
          title: mountElement.dataset.title,
          message: mountElement.dataset.message,
          buttonLabel: mountElement.dataset.buttonLabel,
          loginUrl: mountElement.dataset.loginUrl,
        },
      });
    },
  });
});
